import { render, staticRenderFns } from "./SmallCreditCard.vue?vue&type=template&id=35b8849e"
import script from "./SmallCreditCard.vue?vue&type=script&lang=js"
export * from "./SmallCreditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports